/**
 * Keeps casual visitors from saving the artwork pictures: the context menu (right-click,
 * and long-press on Android) and dragging are blocked on images and videos.
 * A deterrent only; screenshots still work, so the stored files are also kept at
 * screen resolution. The iOS long-press callout is turned off in fifi-art-house.css.
 */
const GUARDED = 'img, picture, video';

/** @param {Event} event */
function guard(event) {
  if (event.target instanceof Element && event.target.closest(GUARDED)) event.preventDefault();
}

document.addEventListener('contextmenu', guard);
document.addEventListener('dragstart', guard);
